import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { IconButton, type Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getAdjustButtonStyles } from './styles';

interface TemperatureAdjustButtonProps {
  direction: 'increase' | 'decrease';
  disabled: boolean;
  onAdjust: () => void;
  theme: Theme;
}

export function TemperatureAdjustButton({
  direction,
  disabled,
  onAdjust,
  theme,
}: TemperatureAdjustButtonProps) {
  const { t } = useTranslation();
  const Icon = direction === 'increase' ? AddIcon : RemoveIcon;
  const ariaLabel =
    direction === 'increase' ? t('temperature.increaseTemp') : t('temperature.decreaseTemp');

  return (
    <IconButton
      onClick={onAdjust}
      disabled={disabled}
      sx={getAdjustButtonStyles(theme)}
      aria-label={ariaLabel}
    >
      <Icon
        sx={{
          fontSize: { xs: 24, sm: 20 },
          color: theme.palette.text.primary,
        }}
      />
    </IconButton>
  );
}
